// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b4abfb5c","455":"c25592dd","977":"fad6c445"}[chunkId] + ".chunk.js";
};